import { PuzzleBoxState } from '@/store/modules/framePuzzle';

export function getParts(productId: string): string {
    if (productId === '81556') {
        return '73'
    }
    if (productId === '81350') {
        return '25'
    }
    return ''
}

export function getProductId(parts: string): string {
    if (parts === '73') {
        return '81556'
    }
    if (parts === '25') {
        return '81350'
    }
    return ''
}